var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tc pt3 legal mid-gray"},[_c('div',[_vm._v("Request will be automatically cancelled in")]),_c('div',{staticClass:"b"},[_vm._v(_vm._s(_vm.timeRemaining))])])}
var staticRenderFns = []

export { render, staticRenderFns }